module.exports = __webpack_public_path__ + "static/images/static-rider.38TgnSG.svg";